// What an appeal level is called in a state (level_names — Table Management → Level Names, step 8 part 5a), for the
// Tax Savings Appeal Summary's ValueType column. A state's own name, else the '*' (every other state) row, else the
// app's label (reports/appealLevels). Only that layout reads it; the reports' Level column is unchanged.
import { supabase } from '../supabase';
import { appealLevelLabel } from '../reports/appealLevels';

export const NAMED_LEVELS = ['appeal_one', 'appeal_two', 'appeal_three', 'appeal_four'];

// → { ok: true, data: [{ state, appeal_level, name }] } or { ok: false, error }
export async function loadLevelNames() {
  const { data, error } = await supabase.from('level_names').select('state, appeal_level, name');
  return error ? { ok: false, error: `Level names could not be loaded: ${error.message}` } : { ok: true, data: data || [] };
}

export function levelNameFor(levelNames, state, level) {
  const find = (st) => (levelNames || []).find((r) => r.state === st && r.appeal_level === level)?.name;
  return find(String(state || '').toUpperCase()) || find('*') || appealLevelLabel(level);
}
